import { DONE, ACTIVE, INACTIVE } from './constants';

export const getStatus = (index, indexOfCurrentStep) => {
  if (index < indexOfCurrentStep) {
    return DONE;
  }
  if (index === indexOfCurrentStep) {
    return ACTIVE;
  }
  return INACTIVE;
};

export const generateColors = (theme) => ({
  [DONE]: theme.palette.fixed.black,
  [ACTIVE]: theme.palette.background.green.main,
  [INACTIVE]: theme.palette.background.grey.main
});
